exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reissue {\n  text-align: center;\n}\n.reissue-table {\n  display: table;\n  height: 100%;\n  width: 100%;\n}\n.reissue-cell {\n  display: table-cell;\n  vertical-align: middle;\n  text-align: center;\n}\n.reissue-error {\n  padding: 30px;\n  display: inline-block;\n  text-align: center;\n  max-width: 60%;\n  border: 1px solid #333333;\n}\n.reissue-error p {\n  font-size: 36px;\n  color: #333333;\n}\n.reissue-error .icon {\n  font-size: 76px;\n  color: #a94442;\n}\n.reissue-success {\n  padding: 0 30px 30px;\n}\n.reissue-success .icon {\n  font-size: 100px;\n  color: #333333;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mattspringbett/sites/cycler/apollo-admin/src/src/app/reissue/reissue.component.less
// module id = ../../../../../src/app/reissue/reissue.component.less
// module chunks = 1